import { BeaconUserPicks } from "components/Pickem/UserPicks/BeaconUserPicks";
import { PickemUserPicks } from "components/Pickem/UserPicks/PickemUserPicks";
import { ErrorText } from "styles/text";

interface Props {
  uid: string;
  tournamentId: string;
}

const BEACON_TOURNAMENTS = ["BwlS1", "BwlS2", "Bdlx1"];
export const PickemUserPageContent = ({ uid, tournamentId }: Props) => {
  return (
    <>
      {!!tournamentId ? (
        BEACON_TOURNAMENTS.includes(tournamentId) ? (
          <BeaconUserPicks uid={uid} tournamentId={tournamentId} />
        ) : (
          <PickemUserPicks uid={uid} tournamentId={tournamentId} />
        )
      ) : (
        <ErrorText>Unable to find Tournament</ErrorText>
      )}
    </>
  );
};
